/**
 * Google Analytics 4 (GA4) tracking utility
 * Provides event tracking with proper error handling
 * Measurement ID: G-53YVW93JPT
 */

/**
 * Track a custom event in Google Analytics
 * @param {string} eventName - The name of the event (lowercase with underscores, e.g., 'sign_up')
 * @param {Object} eventParams - Optional parameters for the event
 */
export const trackEvent = (eventName, eventParams = {}) => {
  try {
    // Check if gtag is available
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('event', eventName, eventParams);
      console.log(`[GA4] ✅ Event tracked: ${eventName}`, eventParams);
    } else {
      console.warn(`[GA4] ⚠️ gtag not available for event: ${eventName}`);
    }
  } catch (error) {
    console.error(`[GA4] ❌ Error tracking event ${eventName}:`, error);
  }
};

/**
 * Track page view for Single Page Application (SPA)
 * CRITICAL: Call this on every route change to populate Pages & Screens report
 * @param {string} pagePath - The page path (e.g., '/home', '/events/123')
 * @param {string} pageTitle - The page title
 */
export const trackPageView = (pagePath, pageTitle) => {
  try {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      // Send page_view event with full context
      window.gtag('event', 'page_view', {
        page_path: pagePath,
        page_title: pageTitle || document.title,
        page_location: window.location.href,
      });
      
      console.log(`[GA4] 📄 Page view tracked: ${pagePath} - ${pageTitle || document.title}`);
    } else {
      console.warn(`[GA4] ⚠️ gtag not available for page view: ${pagePath}`);
    }
  } catch (error) {
    console.error('[GA4] ❌ Error tracking page view:', error);
  }
};

// GA4 Event Names (lowercase with underscores per GA4 naming convention)
export const AnalyticsEvents = {
  // Core MVP Events (CRITICAL)
  SIGN_UP: 'sign_up',                          // 🎯 Conversion
  LOGIN: 'login',
  LOGOUT: 'logout',
  PROFILE_APPROVED: 'profile_approved',        // 🎯 Conversion
  
  // Event Management
  VIEW_EVENT: 'view_event',
  JOIN_EVENT: 'join_event',                    // 🎯 Conversion
  LEAVE_EVENT: 'leave_event',
  CREATE_EVENT: 'create_event',
  SHARE_EVENT: 'share_event',
  
  // Messaging
  SEND_MESSAGE: 'send_message',
  VIEW_CONVERSATION: 'view_conversation',
  
  // Social
  SEND_FRIEND_REQUEST: 'send_friend_request',
  ACCEPT_FRIEND_REQUEST: 'accept_friend_request',
  
  // Meetups
  VIEW_MEETUP: 'view_meetup',
  JOIN_MEETUP: 'join_meetup',
  CREATE_MEETUP: 'create_meetup',
  
  // Other
  WAITLIST_JOIN: 'waitlist_join',
  PROFILE_UPDATE: 'profile_update',
};

export default trackEvent;
